import { gql } from '@apollo/client'

export const KUSTOMER_CONVERSATION_MESSAGES = gql`
  query kustomerConversationMessages($conversationId: String!) {
    kustomerConversationMessages(conversationId: $conversationId) {
      messages {
        id
        direction
        preview
        subject
      }
    }
  }
`
